/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDarkMenuItemExpandable } from "./d-theme-dark-menu-item-expandable";

export class DThemeDarkMenuSidedItemExpandable extends DThemeDarkMenuItemExpandable {}
